(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rmu-store-footer"] && !Shopify.designMode) return;
  try {
    
  // Reopen Shopify's native consent panel from the footer and the cookie policy.
  let privacyBannerLoading;
  function loadPrivacyBanner() {
    if (window.privacyBanner?.showPreferences) return Promise.resolve();
    if (!privacyBannerLoading) {
      privacyBannerLoading = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      }).catch((error) => {
        privacyBannerLoading = undefined;
        throw error;
      });
    }
    return privacyBannerLoading;
  }
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-rmu-cookie-preferences]');
    if (!(trigger instanceof HTMLButtonElement) || trigger.disabled) return;
    trigger.disabled = true;
    try {
      await loadPrivacyBanner();
      await window.privacyBanner.showPreferences();
    } catch (error) {
      console.error('RMU: Shopify cookie preferences could not be opened.', error);
      window.location.assign('/pages/politica-de-cookies');
    } finally {
      trigger.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
